import { ReactNode, createContext, useContext } from "react";
import { useFilterEmploymentStatus } from "./filter-employment-status.hook";

const FilterEmploymentStatusContext = createContext(
  {} as ReturnType<typeof useFilterEmploymentStatus>
);
export function useFilterEmploymentStatusContext() {
  return useContext(FilterEmploymentStatusContext);
}

interface FilterEmploymentStatusProviderProps {
  children: ReactNode;
}
export function FilterEmploymentStatusProvider({
  children,
}: FilterEmploymentStatusProviderProps) {
  return (
    <FilterEmploymentStatusContext.Provider value={useFilterEmploymentStatus()}>
      {children}
    </FilterEmploymentStatusContext.Provider>
  );
}